module.exports = __webpack_public_path__ + "static/media/1POLICY43.113f43de.jpg";